module.exports = __webpack_public_path__ + "static/img/logo.c649caa.png";